import { PageHeading, UserRoleHeading } from "@/components/Layout/Parts";
import InvoicesPreferencesTable from "./components/InvoicesPreferencesTable";

const InvoicesPreferences = () => {
  return (
    <>
      <UserRoleHeading />
      <PageHeading>Receiver List</PageHeading>
      <InvoicesPreferencesTable />
    </>
  );
};

export default InvoicesPreferences;
